var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('sword-header'),_c('main',{staticClass:"layout-main"},[(_vm.$slots.default)?_vm._t("default"):_c('router-view')],2),_c('sword-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }